export default __webpack_public_path__ + "maps-examples-runtime-multiple-annotations-1200-ee03fa5b7139de6a73bc95a903613ea9.png";